// src/utils/currencyConverter.js

const convertToUSD = (currency, amount) => {
  const exchangeRates = {
    USD: 1,
    EUR: 0.92,
    GBP: 0.78,
    INR: 83.00,
    PKR: 280.00,
    AUD: 1.61,
    CAD: 1.35,
    JPY: 148.50,
    SAR: 3.75, // Ensure this exists
  };

  const conversionRate = exchangeRates[currency.toUpperCase()];

  if (!conversionRate) {
    throw new Error(`Unsupported currency: ${currency}`);
  }

  return amount / conversionRate;
};

// utils.js
export const exchangeRates = {
  USD: 1,
  EUR: 0.92,
  GBP: 0.78,
  INR: 83.00,
  AUD: 1.61,
  CAD: 1.35,
  JPY: 148.50,
  PKR: 280,
  SAR: 3.75, // Ensure this exists

};


export default convertToUSD;
